//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { disableBodyScroll, enableBodyScroll, clearAllBodyScrollLocks } from 'body-scroll-lock'
export default {
  props: {
    size: {
      type: String,
      required: false,
      default: 'small'
    },
    right:{
      type: Boolean,
      required: false,
      default: false
    },
    padding:{
      type: Boolean,
      required: false,
      default: true
    },
    dark:{
      type: Boolean,
      required: false,
      default: false
    }
  },
  data() {
    return {

    }
  },
  mounted() {
    const content = document.querySelector(".wrapper-inner");
    content.addEventListener("click", this.closeSidebar);
    const wrapper = document.querySelector(".wrapper");
    wrapper.classList.add('overflow-hidden');
    this.disableScroll();
  },
  beforeDestroy () {
    const content = document.querySelector(".wrapper-inner");
    content.removeEventListener('click', this.closeSidebar)
    const wrapper = document.querySelector(".wrapper");
    wrapper.classList.remove('overflow-hidden');
    clearAllBodyScrollLocks();
  },
  methods: {
    closeSidebar() {
      this.$store.commit('sidebars/asideClose')
    },
    disableScroll() {
      disableBodyScroll(document.body, {
        allowTouchMove: el => {
          while (el && el !== document.body) {
            if (el.getAttribute('body-scroll-lock-ignore') !== null) {
              return true;
            }

            el = el.parentElement;
          }
        },
      });
    }
  },
}
